import { COPY } from "../content/copy";

export function ExpiredRoute() {
  return (
    <main className="landing">
      <div className="landing__form">
        <h1 className="landing__heading">{COPY.expired.heading.text}</h1>
        <p className="landing__error" style={{ color: "var(--paper-quiet)" }}>
          {COPY.expired.body.text}
        </p>
      </div>
    </main>
  );
}
